import { ProductInfoProduct } from '../../../../types'

export const getCardImageUrl = ({
  isDynamicImagesEnabled,
  product,
}: {
  isDynamicImagesEnabled: boolean
  product: ProductInfoProduct
}): string => {
  const dynamicLargeImageUrl = product.dynamicImages?.large.webp[0]?.url
  const dynamicMediumImageUrl = product.dynamicImages?.medium.webp[0]?.url

  const shouldUseDynamicAgeImage =
    isDynamicImagesEnabled && dynamicLargeImageUrl && dynamicMediumImageUrl

  if (shouldUseDynamicAgeImage) {
    return dynamicLargeImageUrl
  }

  const firstImage = product.masterVariant.productImages.images[0]

  return firstImage.large.webpUrl || firstImage.large.jpgUrl
}
